module.exports = __webpack_public_path__ + "img/slika-1.becbce7b.png";